export * from './confirm-equal-validator.directive';



// WEBPACK FOOTER //
// ./src/app/shared/directives/index.ts